<template>
  <div 
    class="e-accordions__accordion"
    v-bind:class="{ 'e-accordions__accordion--arrow' : triggerType == 'Arrow' }"
  >
    <button
      @click="toggleOpen()"
      class="e-accordions__accordion-button"
      v-bind:class="{ isOpen: open }"
      :aria-expanded="open"
      aria-label="Open section"
      :aria-controls="id"
    >
      <div class="e-accordions__accordion-title">{{ title }}</div>

      <span v-if="triggerType == 'Chevron'" class="e-accordions__chevron"></span>
      <span v-else class="e-accordions__arrow">
        <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24"><path d="m5.214 14.522s4.505 4.502 6.259 6.255c.146.147.338.22.53.22s.384-.073.53-.22c1.754-1.752 6.249-6.244 6.249-6.244.144-.144.216-.334.217-.523 0-.193-.074-.386-.221-.534-.293-.293-.766-.294-1.057-.004l-4.968 4.968v-14.692c0-.414-.336-.75-.75-.75s-.75.336-.75.75v14.692l-4.979-4.978c-.289-.289-.761-.287-1.054.006-.148.148-.222.341-.221.534 0 .189.071.377.215.52z" fill="#151236" fill-rule="nonzero"/></svg>
      </span>
    </button>
    <div
      :id="id"
      v-show="open"
      class="e-accordions__accordion-content u-content"
      
      :aria-hidden="!open"
    >
      <div v-if="!containsTable" v-html="expandedContent"></div>
      <v-runtime-template v-else :template="expandedContent"></v-runtime-template>
    </div>
  </div>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template";
import VueTinySlider from 'vue-tiny-slider';
export default {
  name: "Accordion",
  props: {
    title: String,
    triggerType: String,
    containsTable: Boolean,
    expandedContent: String,
    initOpen: Boolean,
  },
  components: {
    "vue-tiny-slider": VueTinySlider,
    "v-runtime-template": VRuntimeTemplate,
  },
  mounted() {
    this.id = this._uid;
    
    // if this is desktop, and initOpen is true, set open to true
    if (window.innerWidth > 1024 && this.initOpen == true) {
      this.open = this.initOpen;
    }
  },
  data() {
    return {
      id: null,
      open: false,
    };
  },
  methods: {
    toggleOpen: function () {
      this.open = !this.open;
      // this.accordionTracking();
    },
    // accordionTracking() {
    //   const pageLocation = window.location.pathname;

    //   dataLayer.push({
    //     event: "custom_accordion_opened",
    //     accordion_title: this.title,
    //     page_url: pageLocation,
    //   });
    // },
  },
};
</script>

<style scoped lang="scss">
</style>
